<div class="modal-header">
  <h6 class="modal-title" i18n>Copy Rooms From</h6>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <app-select-rooms-table [excludedRentalIds]="[rental.id]" (selected)="onSelect($event)"></app-select-rooms-table>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="dialogRef.close()">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button
    type="button"
    class="btn btn-secondary-warning"
    [disabled]="!selectedRooms?.length || isLoading"
    (click)="onOverwrite()"
    matTooltip="It will replace your current settings"
    i18n-matTooltip
  >
    <i class="far fa-spin fa-spinner" *ngIf="isLoading"></i>
    <ng-container i18n>Overwrite</ng-container>
  </button>
  <button
    type="button"
    class="btn btn-secondary-info"
    [disabled]="!selectedRooms?.length || isLoading"
    (click)="onAdd()"
    matTooltip="Selected settings will be added to your rental"
    i18n-matTooltip
  >
    <i class="far fa-plus" *ngIf="!isLoading"></i>
    <i class="far fa-spin fa-spinner" *ngIf="isLoading"></i>
    <ng-container i18n>Add</ng-container>
  </button>
</div>
